var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68755 7.15018C9.6872 7.85742 9.40591 8.53556 8.90556 9.03541C8.40521 9.53525 7.72679 9.81587 7.01955 9.81551C6.31231 9.81516 5.63417 9.53387 5.13432 9.03352C4.63448 8.53317 4.35386 7.85476 4.35422 7.14751C4.35457 6.44027 4.63586 5.76213 5.13621 5.26228C5.63656 4.76244 6.31497 4.48182 7.02222 4.48218C7.72946 4.48253 8.4076 4.76382 8.90745 5.26417C9.40729 5.76452 9.6879 6.44293 9.68755 7.15018ZM9.76755 11.7902H4.43422V28.4835H9.76755V11.7902ZM18.1942 11.7902H12.8876V28.4835H18.1409V19.7235C18.1409 14.8435 24.5009 14.3902 24.5009 19.7235V28.4835H29.7675V17.9102C29.7675 9.68351 20.3542 9.99018 18.1409 14.0302L18.1942 11.7902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.2d5427cbb30a70c48ba27b40c865dd17.svg";
export { ForwardRef as ReactComponent };